import { render, staticRenderFns } from "./CusInfo.vue?vue&type=template&id=443b405c&scoped=true&"
import script from "./CusInfo.vue?vue&type=script&setup=true&lang=js&"
export * from "./CusInfo.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CusInfo.vue?vue&type=style&index=0&id=443b405c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443b405c",
  null
  
)

export default component.exports